import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { StationRouteStationContext, useModalConfirm } from "@ryde/redux";
import { ConfirmResult } from "@ryde/shared";

import { StationHeaderRightIconsWrapperStyled } from "./station-route.station.styled";

export const StationRowButtonsStationRoute: FC = () => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const { removeStationRouteStation, station } = useContext(
    StationRouteStationContext,
  );

  const removeStationHandler = useEvent(async () => {
    const confirmationResult = await confirmDialogResult({
      title: t("stationRoute.waypoint.DELETE_CONFIRM_TITLE"),
      message: t("stationRoute.waypoint.DELETE_CONFIRM_MESSAGE", {
        address: station?.name ?? "",
      }),
    });

    if (confirmationResult !== ConfirmResult.OK) {
      return;
    }

    await removeStationRouteStation?.();
  });

  return (
    <StationHeaderRightIconsWrapperStyled>
      <SVG_MUI.Trash2SVG
        className="pointer trash"
        onClick={removeStationHandler}
      />
    </StationHeaderRightIconsWrapperStyled>
  );
};
